import styled from 'styled-components'

export const Wrapper = styled.div``
export const Content = styled.div`
  & > *:last-child {
    margin-bottom: 0;
  }

  & p {
    margin-bottom: 15px;
    font-weight: var(--font-regular);
    font-size: 16px;
    line-height: 1.6;
  }

  & small {
    color: darkgrey;
    display: block;
    margin-top: 40px;
    font-weight: var(--font-light);
    line-height: 22px;
  }

  & strong {
    font-weight: var(--font-bold);
  }
`
